// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-menu .v-list-item[data-v-42c24f68]{min-height:45px}.nav-menu .v-list-item__icon[data-v-42c24f68]{height:22px;margin-bottom:auto;margin-top:auto}.nav-menu .primary--text[data-v-42c24f68]{cursor:default}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
